import type { ReactNode } from 'react';

const HEADER_CLASS = 'flex w-full items-center justify-between border-b border-light-gray pb-6';
const TITLE_GROUP_CLASS = 'flex flex-col';
const TITLE_CLASS = 'm-0 p-0 text-dark-gray text-super-heavy font-heavy';
const SUBTITLE_CLASS = 'text-gray text-small';
const ACTIONS_CLASS = 'flex items-center gap-4';

type PageHeaderProps = Readonly<{
    title: string;
    subtitle: string;
    actions: ReactNode;
}>;

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
    return (
        <header className={HEADER_CLASS}>
            <div className={TITLE_GROUP_CLASS}>
                <h1 className={TITLE_CLASS}>{title}</h1>
                <p className={SUBTITLE_CLASS}>{subtitle}</p>
            </div>
            <div className={ACTIONS_CLASS} role="toolbar" aria-label="Actions du header">
                {actions}
            </div>
        </header>
    );
}
